const chips = direction => ({
  deleteIcon: {
    margin: direction === 'rtl' ? '0 -8px 0 4px' : '0 4px 0 -8px',
  },
});

export default chips;
